import axios, { AxiosResponse } from "axios";
import { shareDataService } from "@/service/sharedataservice";
import store from "@/store";
import router from "@/router";
import i18n from "@/translations";

export default {
  defaultAxiosOptions: {
    baseURL: "https://api.vti-test.xyz/api/",
  },

  defaultHeaderOptions: {
    "Content-Type": "application/json",
  },

  initialization(defaultOptions: any, headerCommonOptions?: any) {
    axios.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem("token");
        if (token) {
          config.headers.Authorization = "Bearer " + token;
        }
        config.headers["Accept-Language"] =
          store.state?.appModule?.language || "en";
        return config;
      },
      (error) => {
        Promise.reject(error);
      },
    );

    // config default settings
    this._configDefaultsSettings(defaultOptions);

    this._configAxiosHeaderCommon(headerCommonOptions);
    this._configAxiosResponseInterceptor(
      this._interceptorResolve,
      this._interceptorReject,
    );
  },

  _configDefaultsSettings(options: any) {
    const settings = Object.assign(this.defaultAxiosOptions, options || {});

    Object.keys(settings).forEach((key: any) => {
      (axios.defaults as any)[key] = settings[key];
    });
  },

  _configAxiosHeaderCommon(options: any) {
    const settings = Object.assign(this.defaultHeaderOptions, options);

    Object.keys(settings).forEach((key: any) => {
      axios.defaults.headers.common[key] = settings[key];
    });
  },

  // Config after login
  _configAxiosToken(AUTH_TOKEN: any, deleteIfExists: any) {
    if (!AUTH_TOKEN || AUTH_TOKEN.trim() === "") {
      return;
    }

    const currentAuth = axios.defaults.headers.common.Authorization;
    if (currentAuth === "Bearer " + AUTH_TOKEN) {
      return;
    }

    if (deleteIfExists) {
      delete axios.defaults.headers.common.Authorization;
    }

    axios.defaults.headers.common.Authorization = "Bearer " + AUTH_TOKEN;
  },

  _deleteAxiosToken() {
    delete axios.defaults.headers.common.Authorization;
  },

  _interceptorResolve(response: AxiosResponse) {
    return response.data;
  },

  _interceptorReject(error: any) {
    // Handle error
    if (error.response) {
      if (error.response.status === 401) {
        if (localStorage.token) {
          // remove token
          localStorage.removeItem("token");
          store.dispatch("logout");
          alert(i18n.t("common.messages.token_expired"));
        } else {
          store.dispatch("logout");
        }
        router.replace({
          name: "login",
          query: {
            lang:
              router.currentRoute.query.lang ||
              store.state?.appModule?.language,
          },
        });
      } else {
        shareDataService.showDialog(
          i18n.t("common.title_dialog.error").toString(),
          error.response.data?.message ||
            i18n.t("common.messages.common_error"),
        );
      }
    }
    throw error.response ?? error;
  },

  // intercept requests or responses before they are handled by then or catch
  _configAxiosResponseInterceptor(resolve: any, reject: any) {
    if (
      !resolve ||
      !reject ||
      typeof resolve !== "function" ||
      typeof reject !== "function"
    ) {
      return;
    }

    // Add a response interceptor
    axios.interceptors.response.use(
      (response) => {
        // return response;
        if (response.status === 200 || response.status === 201) {
          return resolve(response);
        } else {
          return reject({
            error: response,
          });
        }
      },
      (error) => {
        return reject(error);
      },
    );
  },
};
